/* eslint-disable */

import jQuery from 'jquery';
/**
 * Error handling UI and accessibility.
 */
export default class a11yErrorHandler {
	constructor( types, formId, ccFieldId ) {
		/**
		 * List of messages to be spoken.
		 *
		 * @member {Array} speechMessages
		 */
		this.speechMessages = [];

		/**
		 * setTimeout Speak function handler.
		 *
		 * @int speaker
		 */
		this.speaker = null;

		/**
		 * Errors object, contains all current error messages with field types as keys.
		 *
		 * @Object errors
		 */
		this.errors = {};

		/**
		 * GFSquare input types (card number, cvv, ..etc ).
		 *
		 * @array types
		 */
		this.types = types;

		/**
		 * The form ID.
		 *
		 * @string formId
		 */
		this.formId = formId;

		/**
		 * The field ID.
		 *
		 * @string fieldId
		 */
		this.ccFieldId = ccFieldId;
	}

	/**
	 * Adds an error.
	 *
	 * @param  type    field type.
	 * @param  message error message.
	 */
	push( type, message ) {
		// Sometimes different types return the same message.
		// Since this is a single element, it doesn't make since to show the same message twice.
		if ( this.messageExists( message ) ) {
			return;
		}
		// Make sure provided type is a field type we already have.
		type = this.getErrorType( type );
		this.errors[ type ] = message;
		// Display error and add it to speech array.
		this.declareError( type, message );
		// delay invoking the speak function in case more errors are being pushed.
		setTimeout( this.speak.bind( this ), 500 );
	}

	/**
	 * Loops through existing messages and makes sure the message about to be shown isn't already there.
	 *
	 * @since 1.7
	 *
	 * @param {string} message The new message.
	 *
	 * @return {boolean}
	 */
	messageExists( message ) {
		let exists = false;
		 Object.keys( this.errors ).forEach( ( type ) => {
			if ( message === this.errors[ type ] ) {
				exists = true;
			}
		} );

		return exists;
	}

	remove( type ) {
		type = this.getErrorType( type );
		this.errors[ type ] = null;
		// Remove error from display.
		this.clearError( type );
	}

	/**
	 * Removes all errors and declares all good status! ready to submit.
	 */
	clearErrors() {
		Object.keys( this.errors ).forEach(
			function( type, index ) {
				this.clearError( type );
			}.bind( this )
		);

		if ( this.speaker ) {
			clearTimeout( this.speaker );
			this.speaker = null;
		}
	}

	getErrorType( type ) {
		// Generic errors appear beneath after field container ( not beneath a particular input like card number ).
		if ( type == null || ! type in Object.keys( this.types ) ) {
			type = 'generic';
		}

		return type;
	}

	/**
	 * Removes error message from UI.
	 *
	 * @param  type field type.
	 */
	clearError( type ) {
		// Get field container.
		const container = this.getFieldContainer( type );
		// If validation message exist after container, find error div within and remove it.
		const $validationMessageContainer = container.next( '.validation_message' );
		if ( $validationMessageContainer.length ) {
			$validationMessageContainer.find( 'div.' + type ).remove();
		}

		// If card holder container, remove error class ( card details container error class is removed in inputEventReceived ).
		if ( type === 'cardHolderName' ) {
			container.removeClass( 'SqPaymentForm--invalid' );
		}
	}

	/**
	 * Displays a single error, adds error message to speech array to be spoken later.
	 *
	 * @param {string}  type    field type.
	 * @param {string}  message error message.
	 * @param {boolean} muted   If the error should not be spoken.
	 */
	declareError( type, message, muted = false ) {
		const container = this.getFieldContainer( type );

		// Add error class to container.
		container.addClass( 'SqPaymentForm--invalid' );
		// Make sure error container exists after field container, if not create it.
		if ( ! container.next( '.validation_message' ).length ) {
			container.after( '<div class="gfield_description validation_message gfield_validation_message"></div>' );
		}
		// get error div or create it.
		const $errorDiv = container.next( '.validation_message' ).find( 'div.' + type );
		if ( $errorDiv.length ) {
			// If error div exists check if it has the same error, otherwise display new error.
			const lastMessage = $errorDiv.text();
			if ( lastMessage !== message ) {
				$errorDiv.text( message );
			}
		} else {
			// Error div for this type never existed, create and display it.
			container.next( '.validation_message' ).append( '<div class="' + type + '">' + message + '</div>' );
		}
		// Add error message to speech array even if it existed before.
		// Blind people need the error message to be spoken again if the error is triggered again while the error message is already displayed.
		this.speechMessages.push( message );
	}

	/**
	 * Combines all current error messages to one message and speaks it.
	 */
	speak() {
		// if speak was already invoked, quit.
		if ( this.speaker !== null ) {
			return;
		}
		this.speaker = setTimeout(
			function() {
				let toSpeak = '';
				// Sometimes the same error message is added to the array twice when field loses focus before submit is clicked, filter repeated messages.
				const uniqueErrors = this.speechMessages.filter(
					function( value, index, self ) {
						return self.indexOf( value ) === index;
					}
				);
				// Generate Error speech by imploding messages array into one string, calling wp.a11y.speak in a loop failed.
				uniqueErrors.forEach(
					function( error, index ) {
						// separate error message by new line so VO don't announce them as one line ( dot was not enough ! ).
						toSpeak += '\n' + error;
					}
				);
				// Finally speak.
				wp.a11y.speak( toSpeak );
				// Reset evey thing for next push.
				this.speaker = null;
				this.speechMessages = [];
			}.bind( this ),
			250
		);
	}

	/**
	 * Gets field container
	 *
	 * @since 1.2
	 *
	 * @param  type field type.
	 *
	 *              return {jQuery}
	 */
	getFieldContainer( type ) {
		if ( type === 'generic' ) {
			return jQuery( '.ginput_container_square_card' );
		}

		return jQuery( '#input_' + this.formId + '_' + this.ccFieldId + '_' + this.types[ type ] );
	}
}

